import { lazy } from 'react';

/** Открывает список версий приложений */
export const AppVersionsPageAsync = lazy(() => import('./AppVersions/AppVersionsPage'));
